import React from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';

import { error, system400 } from 'Mui/styles/color';
import { prizeStatusLabels } from 'client/components/Result/prizeList/getPrizeRedeemStatus';

function PrizeRedeemStatusLabel({ status }) {
    switch (status) {
        case prizeStatusLabels.EXPIRED:
            return <span css={labelStyle}>{i18n.t('label.redeem_expired')}</span>;
        case prizeStatusLabels.HAS_NOT_FILL_FORM:
            return <span css={[labelStyle, alertColorStyle]}>{i18n.t('label.not_fill_form')}</span>;
        case prizeStatusLabels.REDEEMED:
            return <span css={labelStyle}>{i18n.t('label.prize_redeemed')}</span>;
        default:
            return null;
    }
}

export default PrizeRedeemStatusLabel;

const labelStyle = css`
    font-size: 12px;
    font-weight: 500;
    background-color: ${system400.color};
    color: #fff;
    border-radius: 4px;
    z-index: 2;
    position: absolute;
    right: 8px;
    bottom: 6px;
    padding: 4px 6px;
`;

const alertColorStyle = css`
    background-color: ${error.color};
`;
